import { Student } from '../models/FormProps';
import { isEmpty } from './equality';

export default function getStudentDisplayName(student: Student): string {
  return isEmpty(student.index_number) ? student.name : `${student.index_number}. ${student.name}`;
}
